import { Component, OnInit, Input } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap';

import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { ShowHiddenListComponent } from '../show-hidden-list/show-hidden-list.component';
import { DynamicForm } from '../../../types/dynamic-form.types';
import { ShowHiddenRuleModel } from '../../../types/control-show-hidden.types';

@Component({
  selector: 'df-show-hidden-entry',
  templateUrl: './show-hidden-entry.component.html',
  styleUrls: ['./show-hidden-entry.component.css']
})
export class ShowHiddenEntryComponent implements OnInit {
  @Input() dynamicForm: DynamicForm;
  @Input() showHiddenRuleModels: ShowHiddenRuleModel[] = [];
  @Input() readonly: boolean;

  constructor(private commonConfig: DynamicFormCommonConfig, private bsModalService: BsModalService) {}

  ngOnInit() {
    if (!this.showHiddenRuleModels) {
      this.showHiddenRuleModels = [];
    }
  }

  getModels(): ShowHiddenRuleModel[] {
    return this.showHiddenRuleModels;
  }

  add() {
    const bsModalRef = this.bsModalService.show(ShowHiddenListComponent, {
      ignoreBackdropClick: true,
      class: `modal-lg`,
      initialState: {
        dynamicForm: this.dynamicForm,
        ruleModels: this.showHiddenRuleModels
      }
    });
    const component = bsModalRef.content as ShowHiddenListComponent;
    component.ruleModelChange.subscribe((s: ShowHiddenRuleModel[]) => {
      this.showHiddenRuleModels = s;
    });
  }
}
